module.exports = __webpack_public_path__ + "static/media/settings-gray-icon.eaee45d8.svg";